import { render, staticRenderFns } from "./editOnTrialItem.vue?vue&type=template&id=2cb2fe3d&scoped=true&"
import script from "./editOnTrialItem.vue?vue&type=script&lang=js&"
export * from "./editOnTrialItem.vue?vue&type=script&lang=js&"
import style0 from "./editOnTrialItem.vue?vue&type=style&index=0&id=2cb2fe3d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cb2fe3d",
  null
  
)

export default component.exports